import { motion } from "framer-motion";

export default function LegalLayout({ title, updated, children, testid }) {
  return (
    <div data-testid={testid} className="relative bg-[#121311]">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-[420px] bg-[radial-gradient(ellipse_at_top,rgba(202,163,98,0.10),transparent_60%)]" />
      <div className="relative mx-auto max-w-3xl px-6 pb-28 pt-36 md:pt-44">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <p className="mb-4 text-xs font-semibold uppercase tracking-[0.25em] text-[#CAA362]">
            Waidbook Legal
          </p>
          <h1 className="font-serif-display text-4xl font-bold text-white sm:text-5xl lg:text-6xl">
            {title}
          </h1>
          {updated && (
            <p className="mt-4 text-sm text-white/40">Last updated: {updated}</p>
          )}
          <div className="hairline mt-8" />
        </motion.div>

        <motion.article
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="prose-legal mt-10 space-y-6 text-base font-light leading-relaxed text-white/70"
        >
          {children}
        </motion.article>
      </div>
    </div>
  );
}

export function LegalSection({ heading, children }) {
  return (
    <section className="space-y-3">
      <h2 className="font-serif-display text-2xl font-semibold text-white sm:text-3xl">
        {heading}
      </h2>
      <div className="space-y-3">{children}</div>
    </section>
  );
}
